import { FaDiscord, FaTwitter, FaInstagram } from 'react-icons/fa';
import React from "react";
export const Navigation = (props) => {
  const handleClick = (url) => {
    window.open(url);
  };

  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header' style={{ display: 'flex', justifyContent: "flex-start" }}>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          {/* <img src="img/logo.png" alt="" style={{width: 50}}/> */}
          <a className='navbar-brand page-scroll' href='#page-top'>
            The Greyhound Society
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#about' className='page-scroll' style={{cursor: 'default'}}>
                About
              </a>
            </li>
            <li>
              <a href='#services' className='page-scroll'>
                FAQs
              </a>
            </li>
            <li>
              <a href='#features' className='page-scroll'>
                Features
              </a>
            </li>
            <li>
              <a href='#roadmap' className='page-scroll'>
                Roadmap
              </a>
            </li>
            {/* <li>
              <a href='#about' className='page-scroll'>
                About
              </a>
            </li>
            <li>
              <a href='#services' className='page-scroll'>
                The Bar
              </a>
            </li>
            <li>
              <a href='#portfolio' className='page-scroll'>
                Founder Story
              </a>
            </li>             */}
            <li>
              <a href='#team' className='page-scroll'>
                Team
              </a>
            </li>
            <li>
              <button onClick={() => handleClick(props.data ? props.data.instagram : '/')} style={{ padding: 5, margin: 5 }}>
                <li><FaInstagram size={25} /></li>
              </button>
            </li>
            <li>
              <button onClick={() => handleClick(props.data ? props.data.twitter : '/')} style={{ padding: 5, margin: 5 }}>
                <li><FaTwitter size={25} /></li>
              </button>
            </li>
            <li>
              <button onClick={() => handleClick(props.data ? props.data.discord : '/')} style={{ padding: 5, margin: 5, marginRight:15 }}>
                <li><FaDiscord size={25} /></li>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
